import Spinner, { DarkBlueSpinner, GreenSpinner, WhiteSpinner } from '~/components/Spinner/Spinner';

export default Spinner;
export { DarkBlueSpinner, GreenSpinner, WhiteSpinner };
